/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: r2L4x5kulJ

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicShared.module.css"; // plasmic-import: r2L4x5kulJ/css

createPlasmicElementProxy;

export type PlasmicShared__VariantMembers = {};
export type PlasmicShared__VariantsArgs = {};
type VariantPropType = keyof PlasmicShared__VariantsArgs;
export const PlasmicShared__VariantProps = new Array<VariantPropType>();

export type PlasmicShared__ArgsType = { avatars?: React.ReactNode };
type ArgPropType = keyof PlasmicShared__ArgsType;
export const PlasmicShared__ArgProps = new Array<ArgPropType>("avatars");

export type PlasmicShared__OverridesType = {
  root?: Flex__<"button">;
  avatars?: Flex__<"div">;
};

export interface DefaultSharedProps {
  avatars?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicShared__RenderFunc(props: {
  variants: PlasmicShared__VariantsArgs;
  args: PlasmicShared__ArgsType;
  overrides: PlasmicShared__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "button",
        "button__ooL7E",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"avatars"}
        data-plasmic-override={overrides.avatars}
        className={classNames("all", sty.avatars)}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <img
                alt={""}
                className={classNames(
                  "all",
                  "img",
                  "img__ooL7E",
                  sty.img__yZ5Ov
                )}
              />

              <img
                alt={""}
                className={classNames(
                  "all",
                  "img",
                  "img__ooL7E",
                  sty.img__voYmc
                )}
              />

              <img
                alt={""}
                className={classNames(
                  "all",
                  "img",
                  "img__ooL7E",
                  sty.img__z81Bn
                )}
              />
            </React.Fragment>
          ),
          value: args.avatars,
        })}
      </div>
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "avatars"],
  avatars: ["avatars"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  avatars: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicShared__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicShared__VariantsArgs;
    args?: PlasmicShared__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicShared__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicShared__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicShared__ArgProps,
          internalVariantPropNames: PlasmicShared__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicShared__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicShared";
  } else {
    func.displayName = `PlasmicShared.${nodeName}`;
  }
  return func;
}

export const PlasmicShared = Object.assign(
  // Top-level PlasmicShared renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    avatars: makeNodeComponent("avatars"),

    // Metadata about props expected for PlasmicShared
    internalVariantProps: PlasmicShared__VariantProps,
    internalArgProps: PlasmicShared__ArgProps,
  }
);

export default PlasmicShared;
/* prettier-ignore-end */
